import { useEffect, useState } from 'react'
import styles from './FilterCalendar.module.css'
import { DateRange, DefinedRange } from 'react-date-range'
import ru from 'date-fns/locale/ru'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import classNames from 'classnames'
import { useOutsideClick } from '../../hooks/useOutsideClick'
import { staticRangesArray } from '../../constants/date'

interface FilterCalendarProps {
  startDate: Date
  endDate: Date
  onDateChange: (startDate: Date, endDate: Date) => void
  isFixed: boolean
  onOpenChange?: (open: boolean) => void
  horizontalOnDesktop?: boolean
}

function FilterCalendar({
  startDate,
  endDate,
  onDateChange,
  isFixed,
  onOpenChange,
  horizontalOnDesktop = false,
}: FilterCalendarProps) {
  const [isOpen, setIsOpen] = useState(false)
  const [clickCount, setClickCount] = useState(0)
  const [isDesktop, setIsDesktop] = useState(
    () => window.matchMedia('(min-width: 768px)').matches
  )

  useEffect(() => {
    if (!horizontalOnDesktop) return
    const mq = window.matchMedia('(min-width: 768px)')
    const onChange = () => setIsDesktop(mq.matches)
    onChange()
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [horizontalOnDesktop])

  const monthsInRow = horizontalOnDesktop && isDesktop

  const ref = useOutsideClick(() => {
    setIsOpen(false)
    onOpenChange && onOpenChange(false)
  })

  // Создаем диапазон дат в формате, который ожидает react-date-range
  const calendarRange = [
    {
      startDate,
      endDate,
      key: 'selection',
    },
  ]

  useEffect(() => {
    if (clickCount >= 2) {
      setIsOpen(false)
      onOpenChange && onOpenChange(false)
      setClickCount(0)
    }
  }, [clickCount, onOpenChange])

  const handleDateChange = (item: any) => {
    if (item.selection.startDate && item.selection.endDate) {
      onDateChange(item.selection.startDate, item.selection.endDate)
    }
  }

  const formatDateRange = () => {
    if (startDate && endDate) {
      return `${startDate.toLocaleDateString('ru-RU')} - ${endDate.toLocaleDateString('ru-RU')}`
    }
    return 'Выберите даты'
  }

  return (
    <div className={styles.dateRangeMobile} ref={ref}>
      <div className={styles.flexInput}>
        <div
          className={styles.inputCalendar}
          onClick={() => {
            setIsOpen(!isOpen)
            onOpenChange && onOpenChange(!isOpen)
          }}
        >
          <input
            type="text"
            readOnly
            value={formatDateRange()}
            className={classNames(styles.dateInput)}
          />
          <i
            className={`${styles.iconArrowBlue} ${styles.iconArrowBlueInput} ${isOpen ? styles.iconRotateInput : ''}`}
          />
          <i className={`${styles.calendarInput}`} />
        </div>
      </div>

      {isOpen && (
        <>
          {/* Календарь как выпадающее окно */}
          <div
            className={classNames(styles.calendar, {
              [styles.calendarHorizontal]: monthsInRow,
            })}
          >
            <DefinedRange
              className={styles.range}
              onChange={(item) => {
                setClickCount(2)
                handleDateChange(item)
              }}
              inputRanges={[]}
              rangeColors={['#11e651']}
              ranges={calendarRange}
              staticRanges={staticRangesArray}
              renderStaticRangeLabel={(staticRange) => {
                const selected = staticRange.isSelected({ startDate, endDate })
                return (
                  <span
                    className={classNames(styles.staticRangeLabel, {
                      [styles.staticRangeLabelSelected]: selected,
                    })}
                  >
                    {staticRange.label}
                  </span>
                )
              }}
            />
            <DateRange
              className={styles.dateRange}
              rangeColors={['#0f6dba']}
              locale={ru}
              dateDisplayFormat="dd.MM.yyyy"
              editableDateInputs={true}
              onChange={(item) => {
                setClickCount((prev) => (prev += 1))
                handleDateChange(item)
              }}
              moveRangeOnFirstSelection={false}
              ranges={calendarRange}
              months={2}
              direction={monthsInRow ? 'horizontal' : 'vertical'}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default FilterCalendar
